module.exports = __webpack_public_path__ + "static/media/lightMic.f4034669.svg";